import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/lib/translations";

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("aq_lang") || "tr");
  useEffect(() => { localStorage.setItem("aq_lang", lang); }, [lang]);
  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export function useLang() {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
}
